import { cn } from "@bentolabs/kit/utils";
import { VisuallyHidden } from "radix-ui";

import { Dialog } from "shared/ui/dialog";

import { TradeThemeVariant, WithdrawFormType } from "../types";
import { Trade } from "./trade";

type Props = {
  className?: string;
  theme?: TradeThemeVariant;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onWithdrawSubmit: (data: WithdrawFormType, slippage: string) => Promise<void>;
};

export const TradeDialog = ({
  open,
  theme,
  className,
  onOpenChange,
  onWithdrawSubmit,
}: Props) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <Dialog.Content>
        <Dialog.Body className={cn("my-auto", className)}>
          <VisuallyHidden.Root asChild>
            <Dialog.Title>Trade</Dialog.Title>
          </VisuallyHidden.Root>
          <Trade theme={theme} onWithdrawSubmit={onWithdrawSubmit} />
        </Dialog.Body>
      </Dialog.Content>
    </Dialog>
  );
};
